import * as Sentry from '@sentry/nextjs';

export function getSentry(): typeof Sentry | undefined {
  const client = Sentry.getClient();
  if (!client?.getDsn()) {
    return;
  }

  return Sentry;
}
